/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterNoticeDto } from '../../models/center-notice-dto';

export interface ParentCenterNoticeControllerFindById$Params {
  id: string;
}

export function parentCenterNoticeControllerFindById(http: HttpClient, rootUrl: string, params: ParentCenterNoticeControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterNoticeDto>> {
  const rb = new RequestBuilder(rootUrl, parentCenterNoticeControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterNoticeDto>;
    })
  );
}

parentCenterNoticeControllerFindById.PATH = '/api/center-notice/parent/{id}';
